import React  from 'react';
import Accounts from '../../../common/report/transaction/Accounts';

function StoreAccounts(){
  return <Accounts isStore={true}/>
}

export default StoreAccounts;